var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "game-list-block",
      class: { addPaddingTop: _vm.isFixedGameTab },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchKey,
            expression: "searchKey",
          },
        ],
        staticClass: "search-block",
        attrs: { placeholder: _vm.$ln("搜尋遊戲") },
        domProps: { value: _vm.searchKey },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.searchKey = $event.target.value
          },
        },
      }),
      _c(
        "div",
        { staticClass: "game-list-wrapper vld-parent" },
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.loading
                ? _c("LoadingAnimate", {
                    attrs: {
                      "is-loading": true,
                      "is-full-page": false,
                      "bg-color": "#0a1635",
                      "bg-opacity": 0,
                    },
                  })
                : _vm.filterSearch.length > 0
                ? _c(
                    "ul",
                    { staticClass: "game-list" },
                    _vm._l(_vm.filterSearch, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: { refreshEffect: _vm.refreshStatus },
                          on: {
                            click: function ($event) {
                              return _vm.openGame(item)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "game-card",
                            attrs: {
                              src: `/icon/game/dragoonsoft_${
                                item.gameId
                              }_${_vm.translationLang(_vm.language)}.jpg`,
                              alt: "",
                            },
                          }),
                          item.hot
                            ? _c("img", {
                                staticClass: "hot-tag",
                                attrs: {
                                  src: require("@/assets/img/icon/hot_tag.png"),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                          item.latest
                            ? _c("img", {
                                staticClass: "new-tag",
                                attrs: {
                                  src: require("@/assets/img/icon/new_tag.png"),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "no-result-block" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/icon/search_no_result.png"),
                        alt: "",
                      },
                    }),
                    _vm.resultGameList.length > 0
                      ? _c("span", [_vm._v(_vm._s(_vm.$ln("查無遊戲")))])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.$ln("未開啟遊戲權限")) + "(1019)"),
                        ]),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }